import React from 'react';

import PackageIncludesMessage from '../../../../components/package-includes-message/package-includes-message';
import ProductFlags from '../../../../components/product-flags/product-flags';
import ProductImageGallery, {
  GalleryImages
} from '../../../../components/product-image-gallery/product-image-gallery';

import { useMediaQuery } from '../../../../shared/hooks/hooks';

import { getGalleryImagesByProductType } from '../../../../shared/utils/product-detail-utils/product-detail-utils';

import {
  BundleData,
  ProductData
} from '../../../../shared/types/graphql-types';
import { PRODUCT_TYPES } from '../../../../shared/constants/products';

import './pdp-gallery-section.scss';

interface PdpGallerySectionProps {
  fallbackProductImage: string;
  galleryImages: GalleryImages;
  isNoLongerAvailable: boolean;
  prebuiltPackage: BundleData;
  product: ProductData;
  showFallbackProductImage?: boolean;
}

function PdpGallerySection(props: PdpGallerySectionProps) {
  const {
    fallbackProductImage,
    galleryImages,
    isNoLongerAvailable,
    prebuiltPackage,
    product,
    showFallbackProductImage
  } = props;

  const breakpoint = useMediaQuery();

  return (
    <>
      {!breakpoint.isMinSm && !isNoLongerAvailable && prebuiltPackage && (
        <PackageIncludesMessage isPrebuiltPackage />
      )}
      <ProductFlags
        prebuiltPackage={prebuiltPackage}
        product={product}
        styleName="product-description-flag"
      />
      <ProductImageGallery
        fallbackProductImage={fallbackProductImage}
        galleryImages={
          prebuiltPackage
            ? getGalleryImagesByProductType(galleryImages, PRODUCT_TYPES.TIRES)
            : galleryImages
        }
        showFallbackProductImage={showFallbackProductImage}
      />
      {breakpoint.isMinSm && prebuiltPackage && (
        <ProductImageGallery
          fallbackProductImage={fallbackProductImage}
          galleryImages={getGalleryImagesByProductType(
            galleryImages,
            PRODUCT_TYPES.WHEELS
          )}
          showFallbackProductImage={showFallbackProductImage}
        />
      )}
    </>
  );
}

export default PdpGallerySection;
